import React, { createContext, useState } from 'react';

export const UiContext = createContext(false);

const UiContextProvider = ({ children }) => {
    const [isCollapsedSidebar, setIsCollapsedSidebar] = useState(true);
    const [isActiveChat, setIsActiveChat] = useState(false);

    const toggleSidebar = () => {
        setIsCollapsedSidebar(!isCollapsedSidebar);
    }

    const toggleChat = () => {
        setIsActiveChat(!isActiveChat);
    }

    return (
        <UiContext.Provider value={{ isCollapsedSidebar, toggleSidebar, isActiveChat, toggleChat }}>
            {children}
        </UiContext.Provider>
    );
};

export default UiContextProvider;
